import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { configure } from 'vee-validate'
import { pluralizationRules, translations } from '@/i18n/languages'
import { dateTimeFormats, numberFormats } from '@/i18n/formats'
import applicationLanguage from '@shared/module/applicationLanguage'
import store from '@shared/store'

Vue.use(VueI18n)

const locale = applicationLanguage()

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    numberFormats,
    dateTimeFormats,
    messages: translations,
    pluralizationRules: pluralizationRules
})

store.setLocale(locale)

configure({
    defaultMessage: (field, values) => {
        return i18n.t(`validation.${values._rule_}`, values)
    }
})

export default i18n
